import React, { useState } from 'react';
import './RecentSheetsTiles.css';
import sheetMapIcon from '../icons/SheetMapIcon.png';

function RecentSheetsTiles({ pinnedMaps, onLoadMap, onUnpinMap, onEditMap, onShareMap, iconSrc }) {
  const displayIcon = iconSrc || sheetMapIcon;
  const [editingMap, setEditingMap] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [shareToast, setShareToast] = useState(null);

  const handlePinnedClick = (savedMap) => {
    onLoadMap(savedMap);
  };

  const handleUnpin = async (e, savedMap) => {
    e.stopPropagation();
    await onUnpinMap(savedMap.url, savedMap.tabName);
  };

  const handleEdit = (e, savedMap) => {
    e.stopPropagation();
    setEditingMap(savedMap);
    setEditedName(savedMap.sheetName);
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    if (editedName.trim() && onEditMap) {
      await onEditMap(editingMap.url, editingMap.tabName, editedName.trim());
    }
    setEditingMap(null);
    setEditedName('');
  };

  const handleCancelEdit = () => {
    setEditingMap(null);
    setEditedName('');
  };

  const handleShare = async (e, savedMap) => {
    e.stopPropagation();
    try {
      const shareUrl = await onShareMap(savedMap);
      // Copy to clipboard
      await navigator.clipboard.writeText(shareUrl);
      // Show toast
      setShareToast('Link copied to clipboard!');
      setTimeout(() => setShareToast(null), 3000);
    } catch (error) {
      console.error('Failed to share map:', error);
      console.error('Error details:', error.message);
      setShareToast(`Failed: ${error.message}`);
      setTimeout(() => setShareToast(null), 5000);
    }
  };

  return (
    <div className="recent-sheets-container">
      <div className="sheets-tiles-grid">
        {/* Pinned maps tiles */}
        {pinnedMaps.map((savedMap, index) => (
          <div
            key={`pinned-${index}`}
            className="sheet-tile pinned"
            onClick={() => handlePinnedClick(savedMap)}
          >
            <div className="tile-actions">
              <button
                className="share-button"
                onClick={(e) => handleShare(e, savedMap)}
                title="Share this map"
              >
                🔗
              </button>
              <button
                className="edit-button"
                onClick={(e) => handleEdit(e, savedMap)}
                title="Edit title"
              >
                ✏️
              </button>
              <button
                className="unpin-button"
                onClick={(e) => handleUnpin(e, savedMap)}
                title="Unpin this map"
              >
                ✕
              </button>
            </div>
            <div className="sheet-tile-icon">
              <img src={displayIcon} alt="Map" />
            </div>
            <h3 className="sheet-tile-name">{savedMap.sheetName}</h3>
            <p className="sheet-tile-tab">{savedMap.tabName}</p>
          </div>
        ))}
      </div>

      {/* Edit modal */}
      {editingMap && (
        <div className="edit-modal-overlay" onClick={handleCancelEdit}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Edit Title</h3>
            <form onSubmit={handleSaveEdit}>
              <input
                type="text"
                value={editedName}
                onChange={(e) => setEditedName(e.target.value)}
                placeholder="Enter new title"
                autoFocus
                className="edit-input"
              />
              <div className="edit-modal-actions">
                <button type="button" onClick={handleCancelEdit} className="btn-cancel">
                  Cancel
                </button>
                <button type="submit" className="btn-save">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Toast notification */}
      {shareToast && (
        <div className="share-toast">
          {shareToast}
        </div>
      )}
    </div>
  );
}

export default RecentSheetsTiles;
